const DESKTOP_BREAKPOINT = 1200;

class ParagraphTypeFact {
  // eslint-disable-next-line class-methods-use-this
  getStartValue(target) {
    if (target <= 0) return 0;
    const magnitude = 10 ** Math.floor(Math.log10(target));
    if (magnitude >= target) return 0;
    return magnitude;
  }

  // eslint-disable-next-line class-methods-use-this
  getScale(number, allNumbers) {
    const min = Math.min(...allNumbers);
    const max = Math.max(...allNumbers);
    if (max === min) return 1;
    const normalized = (number - min) / (max - min);
    const scale = 0.7 + normalized * 0.5;
    if (number > 1000 && scale < 1.0) return 1.0;
    return scale;
  }

  // eslint-disable-next-line class-methods-use-this
  animateCounter(el, from, to, duration) {
    const startTime = performance.now();

    const step = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - (1 - progress) ** 3;
      const current = Math.round(from + (to - from) * eased);

      el.textContent = current.toLocaleString('de-CH');

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }

  // eslint-disable-next-line class-methods-use-this
  animateDescription(el) {
    el.style.opacity = '0';
    el.style.transition = 'opacity 1s ease-in';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.opacity = '1';
      });
    });
  }

  setFacts() {
    const { getStartValue, getScale, animateCounter, animateDescription } =
      this;

    Drupal.behaviors.paragraphTypeFact = {
      attach(context) {
        const wrapper = once(
          'paragraph-type-fact',
          '.field--name-field-facts',
          context
        );

        wrapper.forEach((factsWrapper) => {
          const facts = Array.from(
            factsWrapper.querySelectorAll('.paragraph--type--fact')
          );

          if (!facts.length) return;

          const numbers = facts.map((fact) => {
            const numberEl = fact.querySelector('.field--name-field-number');
            return numberEl
              ? parseInt(numberEl.textContent.trim(), 10) || 0
              : 0;
          });

          const randomOffsets = facts.map(() => Math.floor(Math.random() * 21));

          facts.forEach((fact, index) => {
            fact.style.opacity = '0';

            if (numbers[index] > 100000) {
              const descEl = fact.querySelector(
                '.field--name-field-description'
              );
              if (descEl) {
                descEl.classList.add(
                  'field--name-field-description--extra-large-number'
                );
              }
            } else if (numbers[index] > 10000) {
              const descEl = fact.querySelector(
                '.field--name-field-description'
              );
              if (descEl) {
                descEl.classList.add(
                  'field--name-field-description--large-number'
                );
              }
            }
          });

          const applyHorizontalOffsets = () => {
            const isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;

            facts.forEach((fact, index) => {
              const fieldItem = fact.closest('.field__item');
              if (!fieldItem) return;

              if (!isDesktop) {
                fieldItem.style.transform = '';
                return;
              }

              const offset = randomOffsets[index];
              const isLeftColumn = index % 1.5 === 0;

              if (isLeftColumn) {
                fieldItem.style.transform = `translateX(-${offset}%)`;
              } else {
                fieldItem.style.transform = `translateX(${offset}%)`;
              }
            });
          };

          applyHorizontalOffsets();

          let scrollThrottle = null;
          let resizeThrottle = null;
          const animatedFacts = new Set();

          const tryAnimateFact = (fact, index) => {
            if (animatedFacts.has(index)) return;

            const rect = fact.getBoundingClientRect();
            const inView = rect.top < window.innerHeight && rect.bottom > 0;

            if (!inView) return;

            animatedFacts.add(index);

            const number = numbers[index];
            const scale = getScale(number, numbers);
            const from = getStartValue(number);

            fact.style.transition =
              'opacity 0.5s ease-in, transform 0.5s ease-in';
            fact.style.transform = `scale(${scale})`;
            fact.style.transformOrigin = 'center center';
            fact.style.opacity = '1';

            const numberEl = fact.querySelector('.field--name-field-number');
            const descEl = fact.querySelector('.field--name-field-description');

            if (numberEl) {
              animateCounter(numberEl, from, number, 1500);
            }

            if (descEl) {
              const counterScale = scale !== 0 ? 1 / scale : 1;
              descEl.style.transform = `scale(${counterScale})`;
              descEl.style.transformOrigin = 'center center';
              animateDescription(descEl);
            }
          };

          const checkVisibility = () => {
            facts.forEach((fact, index) => {
              tryAnimateFact(fact, index);
            });
          };

          checkVisibility();

          window.addEventListener('scroll', () => {
            if (scrollThrottle) return;

            scrollThrottle = setTimeout(() => {
              checkVisibility();
              scrollThrottle = null;
            }, 100);
          });

          window.addEventListener('resize', () => {
            if (resizeThrottle) return;

            resizeThrottle = setTimeout(() => {
              applyHorizontalOffsets();
              resizeThrottle = null;
            }, 100);
          });
        });
      }
    };
  }

  run() {
    this.setFacts();
  }
}

export default ParagraphTypeFact;
